import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    espacoAntes,
} from '../../../business-components/Formata/Formata'

import {
    trataValorTexto,
} from '../cliente-form/ClienteServiceImportacao'

import {
    espaco,
    fimLinha,
    identificaTipoCoberturaSeguroVida,
    indexAtualJsonRegistros,
    obtemDadoPDF,
    obtemDadoPDFAvulso,
    jsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosAtualizaErros,
    incluiCoberturas,
} from './IntegracaoClienteArquivoService'



export const importaApoliceSantander = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao,
    seguradora, nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

    //PDFTxt = PDFTxt.replace(fimLinha + 'Vida Em Grupo - Apólice nº:' + fimLinha,
    //    fimLinha + 'Vida Em Grupo - Apólice nº:' + espaco)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'QUEM ESTÁ SEGURADO' + fimLinha, fimLinha,
        HARDCODE.importacaoLinhaDados, true, null, erros, nomeArquivo)
        
    let linhaDados = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(espaco)

    obtemDadoPDFAvulso (jsonRegistros, linhaDados[0], HARDCODE.importacaoDataEmissao,
        true, null, erros, nomeArquivo)

    obtemDadoPDFAvulso (jsonRegistros, linhaDados[1], HARDCODE.importacaoDataTerminoCobertura,
        true, null, erros, nomeArquivo)



    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha,
        fimLinha + 'COBERTURAS CONTRATADAS CAPITAL SEGURADO PRÊMIOFRANQUIA CARÊNCIA (DIAS)' + fimLinha,
            HARDCODE.importacaoCoberturas, true, null, erros, nomeArquivo)



    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'ENDEREÇO' + fimLinha, fimLinha,
        HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, espaco,
        HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, espaco, fimLinha,
        HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)



    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha,
        HARDCODE.importacaoLinhaDados, true, null, erros, nomeArquivo)
        
    linhaDados = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(espaco)

    let indexLinhaDados = 0

    while (indexLinhaDados < linhaDados.length) {

        if (linhaDados[indexLinhaDados].length === 9 && linhaDados[indexLinhaDados].substring(5, 6) === "-") {

            obtemDadoPDFAvulso (jsonRegistros, linhaDados[indexLinhaDados], HARDCODE.importacaoCepSeguradoCliente,
                true, null, erros, nomeArquivo)

            break
        }

        indexLinhaDados++
    }



    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + '93 - VIDA' + espaco, fimLinha,
        HARDCODE.importacaoLinhaDados, true, null, erros, nomeArquivo)
        
    linhaDados = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(espaco)

    obtemDadoPDFAvulso (jsonRegistros, linhaDados[0], HARDCODE.importacaoNumeroProposta,
        true, null, erros, nomeArquivo)

    obtemDadoPDFAvulso (jsonRegistros, linhaDados[1], HARDCODE.importacaoTipoPeriodicidadePagtoPremio,
        true, null, erros, nomeArquivo)



    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha,
        HARDCODE.importacaoLinhaDados, true, null, erros, nomeArquivo)
        
    linhaDados = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(espaco)
    
    obtemDadoPDFAvulso (jsonRegistros, linhaDados[1], HARDCODE.importacaoNumeroApolice,
        true, null, erros, nomeArquivo)



    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'nascido(a) em' + espaco, virgula,
    //    HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Valor do Prêmio Total:' + espaco, fimLinha,
    //    HARDCODE.importacaoValorPremioAnualizado, true, null, erros, nomeArquivo)

    //jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioAnualizado = 
    //    calculaValorAnual(jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioAnualizado,
    //        jsonRegistros.jsonRegistros[indexJsonRegistros].tipoPeriodicidadePagtoPremio) 

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Status da Apólice:' + espaco, espaco,
    //    HARDCODE.importacaoStatusApolice, false, linhaIntegracao.statusApolice, erros, nomeArquivo)
    jsonRegistros.jsonRegistros[indexJsonRegistros].statusApolice = HARDCODE.idStatusApoliceAtiva


        
    jsonRegistros.indexInicial = 0

    if (jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas) {

        const linhasCobertura = []
        let indexLinhasCobertura = 0

        const linhasCoberturaAux = jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.split(fimLinha)
        let indexLinhasPosicaoAux = 0
        let linhaCoberturaAux = ''

        const coberturas = []

        let dadosCobertura
        let indexDadosCobertura

        let numeroCobertura
        let codigoCobertura
        let descricaoCobertura
        let tipoCoberturaSeguroVida
        let valorCS
        let valorPremioLiquido
        let valorIof
        let valorPremio
        let classeAjusteRisco
        let valorPremioExtra
        let duracaoPremioExtra
        let dataTerminoCobertura = jsonRegistros.jsonRegistros[indexJsonRegistros].dataTerminoCobertura
        let valorRendaMensal

        while (indexLinhasPosicaoAux < linhasCoberturaAux.length) {

            if (linhasCoberturaAux[indexLinhasPosicaoAux].indexOf('%') === -1) {

                if (linhasCoberturaAux[indexLinhasPosicaoAux].indexOf('R$ ') === -1) {

                    linhaCoberturaAux = espacoAntes(linhaCoberturaAux, linhasCoberturaAux[indexLinhasPosicaoAux])

                } else {

                    linhasCobertura.push(espacoAntes(linhaCoberturaAux, linhasCoberturaAux[indexLinhasPosicaoAux]))

                    linhaCoberturaAux = ''
                }
            }

            indexLinhasPosicaoAux += 1
        }

        while (indexLinhasCobertura < linhasCobertura.length) {

            dadosCobertura = linhasCobertura[indexLinhasCobertura].split(espaco)

            indexDadosCobertura = 0

            descricaoCobertura = ''

            while (dadosCobertura[indexDadosCobertura] !== 'R$') {

                descricaoCobertura += (descricaoCobertura ? espaco : '') + dadosCobertura[indexDadosCobertura]

                indexDadosCobertura++
            }

            tipoCoberturaSeguroVida = identificaTipoCoberturaSeguroVida(descricaoCobertura, linhaIntegracao,
                jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

            valorCS = trataValorTexto(dadosCobertura[indexDadosCobertura + 1])
            valorPremio = trataValorTexto(dadosCobertura[dadosCobertura.length - 1])

            incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura, tipoCoberturaSeguroVida,
                HARDCODE.idStatusCoberturaAtivaPagandoPremio, valorCS, valorPremioLiquido, valorIof, valorPremio, classeAjusteRisco,
                    valorPremioExtra, duracaoPremioExtra, dataTerminoCobertura, valorRendaMensal)
            
            indexLinhasCobertura++
        }

        jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas = coberturas
    }
    //console.log(jsonRegistros.jsonRegistros[indexJsonRegistros])


    
    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    return jsonRegistros.jsonRegistros
}